import React from 'react';

import { useFeatureFlag } from '../../hooks/useFeatureFlag';
import { ConstantsLagoon } from '../ConstantsLagoon';
import { PSXHeaderProps } from './PSXHeader.types';
import { PSXHeaderWithoutSmartChoiceWidget } from './PSXHeaderWithoutSmartChoiceWidget';
import { PSXHeaderWithSmartChoiceWidget } from './PSXHeaderWithSmartChoiceWidget';

export const PSXHeader = (props: PSXHeaderProps) => {
  const IS_USING_SHAREABLE_SMART_CHOICE_WIDGET = useFeatureFlag([
    ConstantsLagoon.FEATURE_FLAGS.ENABLE_SMART_CHOICE_WIDGET,
  ]);

  return IS_USING_SHAREABLE_SMART_CHOICE_WIDGET ? (
    <PSXHeaderWithSmartChoiceWidget {...props} />
  ) : (
    <PSXHeaderWithoutSmartChoiceWidget {...props} />
  );
};
